export default "__VITE_ASSET__DLcebv21__"